<style lang="scss">
</style>

<template>
    <div class="popup">
        <div class="popup-header">
            <p class="mb-0 fs-17 fw-b">
                <i class="fal fa-trash mr-8"></i>
                {{ $t(`${$options.name}.${type}_title`) }}
            </p>
            <div class="close" @click="$emit('close')"></div>
        </div>
        <div class="popup-content fs-17">
            <el-form @submit="remove" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button`">
                <i18n :path="`${$options.name}.${type}_description`">
                    <strong>"{{ modelCount }}"</strong>
                    <strong>"{{ modelTitle }}"</strong>
                </i18n>
                <template #footerLeft>
                    <span class="btn btn-outline-primary ml-auto" @click="$emit('close')">{{ $t('general.cancel') }}</span>
                </template>
            </el-form>
        </div>
    </div>
</template>

<script>
import HasForm from '@/components/forms/has-form';

export default {
    name: 'popups.user.remove',

    mixins: [HasForm],

    props: {
        modelCount: {
            required: true,
        },
        modelTitle: {
            type: String,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
        modelId: {
            type: Number,
            required: true,
            validator: function (value) {
                return value > 0
            }
        },
        type: {
            type: String,
            required: true,
            validator: function (value) {
                return ['workspace', 'container'].indexOf(value) !== -1
            }
        },
    },

    components: {
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm")
    },

    methods: {
        remove() {
            this.beforeSubmit()
            this.$store.dispatch(`${this.type}/updateUsers`, { model_id: this.modelId, params: this.users })
                .then(() => {
                    this.$emit('close')
                })
                .catch(e => this.handleError(e))
        }
    }
}
</script>